/* eslint-disable react/no-array-index-key */
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogProps,
  DialogTitle,
} from '@material-ui/core';
import SeverityIcon from '@src/components/Common/SeverityIcon';
import { DialogItemConfirm } from './types';

const DialogConfirm = ({
  title,
  description,
  cancelText,
  confirmText,
  cancelVariant = 'outlined',
  confirmVariant = 'contained',
  onCancelClick,
  onConfirmClick,
  type,
  ...dialogProps
}: DialogItemConfirm) => {
  const onCloseDialog: NonNullable<DialogProps['onClose']> = (
    event,
    reason
  ) => {
    if (reason === 'backdropClick' && dialogProps?.disableBackdropClose) return;
    if (reason === 'escapeKeyDown' && dialogProps?.disableEscapeKeyDown) return;

    dialogProps?.onClose?.(event, reason);
  };

  return (
    <Dialog
      {...dialogProps}
      open={dialogProps?.open || false}
      onClose={onCloseDialog}
      fullWidth={dialogProps?.fullWidth ?? true}
      maxWidth={dialogProps?.maxWidth ?? 'xs'}
      disableEscapeKeyDown={dialogProps?.disableEscapeKeyDown}
    >
      {Boolean(title?.length) && (
        <DialogTitle style={{ fontSize: '1.3rem' }}>{title}</DialogTitle>
      )}
      <DialogContent>
        <Box display="flex" alignItems="center">
          {type && (
            <SeverityIcon
              type={type}
              style={{ fontSize: 40, marginRight: 16 }}
            />
          )}
          <Box flex={1}>
            {Array.isArray(description)
              ? description?.map((descriptionItem, index) => {
                  const isLastItem = index !== description.length - 1;
                  return (
                    <div
                      key={index}
                      style={{ marginBottom: isLastItem ? 10 : 0 }}
                    >
                      {descriptionItem}
                    </div>
                  );
                })
              : description}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        {!!cancelText && (
          <Button
            color="primary"
            onClick={onCancelClick}
            variant={cancelVariant}
          >
            {cancelText || 'Cancelar'}
          </Button>
        )}
        <Button
          color="primary"
          onClick={onConfirmClick}
          variant={confirmVariant}
        >
          {confirmText || 'Aceptar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirm;
